import { render } from "./AdminUserCreate.vue?vue&type=template&id=a6a6d53c&scoped=true&ts=true"
import script from "./AdminUserCreate.vue?vue&type=script&lang=ts"
export * from "./AdminUserCreate.vue?vue&type=script&lang=ts"

import "./AdminUserCreate.vue?vue&type=style&index=0&id=a6a6d53c&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6a6d53c"]])

export default __exports__